export const ROUTES = {
  SignUp: '/signup',
  LogIn: '/login',
  Home: '/home',
  Dashboard: '/dashboard',
  TokenRefresh: '/token-refresh',
  Onboarding: '/onboarding',
  Error: '/error',
  AccountSettings: '/account-settings'
}